import home from './home';
import test from './test';

export default { home, test };


// WEBPACK FOOTER //
// ./src/locales/ko-KR/index.ts